module.exports = __webpack_public_path__ + "img/dazed.29c11e76.png";